import sizeRefinementOption from './size-refinement-option';

/**
 * @param {import('../../../../../../type-definitions').Refinement} refinement - refinement
 * @param {import('../../../../../../interface/refinement-url-builder').default} refinementURLBuilder - url builder
 * @param {Object} seoUrlConfig - SEO exclude configuration
 * @returns {string} size refinement HTML
 */
export default (refinement, refinementURLBuilder, seoUrlConfig) => {
    return `
        <div class="sizes">
            ${refinement.sizeMap
                .map(region => {
                    const regionClass = `RegionGroup ${region.selected ? 'active' : ''} ${region.name}group`;
                    return `
                        <div class='${regionClass}' id="${region.name}">
                            <ul class="swatches ${refinement.baseID} ${region.name}"
                                data-region="${region.name}">
                                ${sizeRefinementOption(refinement, region, refinementURLBuilder, seoUrlConfig)}
                            </ul>
                        </div>
                    `;
                })
                .join('')}
        </div>
    `;
};
